@import 'styles/mixins';
@import 'styles/variables';

@value navBarHeight #{$nav-bar-height};

.placeholder {
  position: sticky;
  width: 0px;
  height: 0px;
  display: block;
  background: $white;
  z-index: z-index(pluginPrompt);
  --offsetX: 0px;
  --offsetY: 0px;
  & > .inner {
    position: absolute;
    top: 0;
    left: 0;
    width: max-content;
  }
  // node-specific fixes
  &.table {
    background: red;
    // --offsetX: 61px;
    --offsetY: 22px;
  }
}

.FloatingMenu {
  display: flex;
  .filterInput {
    background: transparent;
  }
  &.up {
    flex-direction: column-reverse;
    .menuWrapper {
      bottom: 0px;
      margin-bottom: 100%;
    }
  }
  &.down {
    flex-direction: column;
    .menuWrapper {
      top: 4px;
    }
  }
  .menuWrapper {
    position: absolute;
    min-width: 280px;
  }
}
